<div class="calendly-shell bg-haleo-warm-light">
    <div class="calendly-close float-right w-10 h-10 rounded-full flex ion-align-items-center bg-white cursor-pointer" (click)="close()">
        <ion-icon
            class="w-full text-4xl"
            slot="icon-only"
            name="close"
        ></ion-icon>
    </div>
    <div id="calendly-inline-embeded" data-auto-load="false"></div>
</div>
